import(/* webpackMode: "eager" */ "/vercel/path0/app/(front)/portfolio/page.tsx");
